import { GQLContentForm } from "@quales/data-access/graphql";
import lodash from "lodash";

export const SetUiOrderForNewItem = (
  uiSchemaPath: string,
  itemName: string,
  formContent: GQLContentForm
) => {
  const getUiOptions = lodash.cloneDeep(formContent.uiSchema);

  if (uiSchemaPath === "") {
    if (Object.hasOwn(formContent.uiSchema, "ui:order")) {
      const uiOrderArray = getUiOptions["ui:order"];
      uiOrderArray.push(itemName);

      getUiOptions["ui:order"] = uiOrderArray;
    } else {
      const uiOrderArray = [];
      uiOrderArray.push(itemName);

      getUiOptions["ui:order"] = uiOrderArray;
    }
  } else {
    const getUISchemaObjectatPath = lodash.get(
      formContent.uiSchema,
      uiSchemaPath
    );

    if (getUISchemaObjectatPath === undefined) {
      const uiOrderArray = [];
      uiOrderArray.push(itemName);

      lodash.set(getUiOptions, uiSchemaPath, {
        ...getUISchemaObjectatPath,
        "ui:order": uiOrderArray,
      });
    } else {
      let uiOrderArray = getUISchemaObjectatPath["ui:order"];
      if (uiOrderArray === undefined) {
        uiOrderArray = [];
      }
      uiOrderArray.push(itemName);

      lodash.set(getUiOptions, uiSchemaPath, {
        ...getUISchemaObjectatPath,
        "ui:order": uiOrderArray,
      });
    }
  }
  return getUiOptions;
};
